import React, { Fragment, useRef, useState, useEffect } from 'react';
import { Col, Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Navbarh from '../navbar/Navbar';
import * as IoIcons from 'react-icons/io';
import '../estilos.css';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import {  Storage } from 'aws-amplify';
import { GetClienteContactos, GetClientes, GetClientesID, GetCotizaciones } from '../queries/Queries';
import { actualizarClientes, guardarCliente } from '../queries/Mutations';
import { getUrl, list } from "@aws-amplify/storage";

//Variables que almacenan los datos del cliente
const initialFormState = {
    cliente: '', activo: true, descripcion: '', domicilio: '', colonia: '',
    ciudad: '', estado: '', pais: '', codigoPostal: '', telefono: '', correo: '',
    rfc: '', razonSocial: '', usoCFDI: '', billTo: '', shipTo: '',
    facturaTipo: 'Invoice', requiereIVA: false, porcentajeIVA: '8 %',
    nombreContacto: '', puestoContacto: '', telefonoContacto: '', correoContacto: '',
    nombreContacto1: '', puestoContacto1: '', telefonoContacto1: '', correoContacto1: '',
    nombreContacto2: '', puestoContacto2: '', telefonoContacto2: '', correoContacto2: '',
    nombreContacto3: '', puestoContacto3: '', telefonoContacto3: '', correoContacto3: '',
    nombreContacto4: '', puestoContacto4: '', telefonoContacto4: '', correoContacto4: '',
    Reg_Ins_Usuario: '', Reg_Mod_Usuario: ''
}

const initialfFormState = { formType: 'Catálogo' }
//Función principal 
function Proveedores() {
    //Declaración de variables
    const [clientes, setClientes] = useState([]);
    const [contactosClientes, setContactosClientes] = useState([]);
    const [clientesCotizacion, setClientesCotizacion] = useState([]);
    const [mClientes, setMClientes] = useState([]);
    const [formState, updateFormState] = useState(initialfFormState);
    const [formData, updateFormData] = useState(initialFormState);
    const [estadoCliente, setEstadoCliente] = useState("todos");
    const [isDisabled, setisDisabled] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [guardarDisable, setGuardarDisabled] = useState(false);
    const [contacto, setContacto] = useState(1);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pclientes = window.$Clientes ? window.$Clientes : false;
    const [aVisible, setAVisible] = useState(false);
    const [imagenRepetida, setImagenRepetida] = useState(true);
    const [imagen, setImagen] = useState([]);
    const [editarImagen, setEditarImagen] = useState(false);
    const inputElement = useRef(null);
    const onDismiss = () => setAVisible(false);
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    //Método useEffect
    useEffect(() => {
        fetchClientes();
        //if (inputElement.current) {
        // inputElement.current.React.focus();
        // }      
    }, []);
    //Guarda la imagen seleccionada
    async function onChangeimage(e) {
        /*setMensajeAlert("Revisando si la imagen ya existe");
        setColor("primary");*/
        setAVisible(false);
        setCargando(true);
        window.scrollTo(0, 0);
        setImagenRepetida(true);
        setGuardarDisabled(true);
        if (!e.target.files[0]) {
            setImagenRepetida(false);
            setGuardarDisabled(false);
            setCargando(false);
            return
        }
        const file = e.target.files[0];
        const imageexist = await list({ path: "public/" + file.name });
        if (imageexist.items.length === 0) {
            setImagenRepetida(false);
            setGuardarDisabled(false);
            setCargando(false);
            setEditarImagen(true);
            setImagen(file);
            updateFormData({ ...formData, image: file.name });
        } else {
            setImagenRepetida(true);
            setMensajeAlert("Ya existe una imagen con el mismo nombre: favor de seleccionar otra imagen o cambiar el nombre de la imagen y volver a intentarlo: ");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            window.scrollTo(0, 0);
        }
    }
    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {
        setAVisible(false);
        setCargando(true);

        const apiData = await GetClientes();
        const clientesFromAPI = apiData;
        await Promise.all(clientesFromAPI.map(async cliente => {
            if (cliente.image) {
                const image = await getUrl({ key: cliente.image }); //await Storage.get(cliente.image);    
                cliente.imagename = cliente.image;
                cliente.image = image.url.toString();
            }
            return cliente;
        }))
        setClientes(apiData);
        setCargando(false);
    }
    //Obtiene los datos guardados de los clientes de la cotización.
    async function fetchClientesCotizacion() {
        setAVisible(false);
        setCargando(true);
        let filter = {
            and: [{
                clienteCatalogo: {
                    eq: false
                }
            },
            {
                activo: {
                    eq: true
                }
            },
            {
                status: {
                    eq: "Accepted"
                }
            }
            ]
        };

        const apiData = await GetCotizaciones(filter);
        setClientesCotizacion(apiData);
        setCargando(false);
    }

    //Revisa cambios en los inputs
    function onChanges(e) {
        e.persist()
        updateFormData(() => ({ ...formData, [e.target.name]: e.target.value }));

    }
    //Revisa cambios en los inputs
    function seleccionarCliente(cliente, i, lista) {
        updateFormData(() => ({
            ...formData, cliente: cliente.cliente, domicilio: cliente.address, ciudad: cliente.ciudad, codigoPostal: cliente.codigoPostal,
            colonia: cliente.colonia, estado: cliente.estado, pais: cliente.pais, correo: cliente.correo,
            telefono: cliente.telefono, nombreContacto: cliente.requestor, puestoContacto: cliente.position,
            telefonoContacto: cliente.desk + ", " + cliente.mobile, correoContacto: cliente.email, idCotizacion: cliente.id
        }));
        lista[i].seleccionado = true;
        toggle();
        return lista;
    }
    //Obtiene el estado seleccionado en el combo de mostrando clientea
    function sClienteEstado(e) {
        e.persist()
        setEstadoCliente(e.target.value);
        setCargando(false);
        setAVisible(false);
    }

    //Prepara los datos del cliente para mostrarlos
    async function onClickCliente(cliente) {
        //Se revisa si hay concurrencia.
        const clienteID = await obtenerClienteporID(cliente.id);
        setCargando(false);
        setAVisible(false);
        updateFormData(clienteID);
        setMClientes(clienteID);
    }

    async function obtenerClienteporID(id) {
        setCargando(true);
        const clientesFromAPI = await GetClientesID(id);
        if (clientesFromAPI.id) {
            if (clientesFromAPI.image) {
                const image = await getUrl({ key: clientesFromAPI.image });//await Storage.get(clientesFromAPI.image);
                clientesFromAPI.imagename = clientesFromAPI.image;
                clientesFromAPI.image = image.url.toString();
            }
        }
        var contactosCliente = [];
        contactosCliente.push({
            nombreContacto: clientesFromAPI.nombreContacto,
            puestoContacto: clientesFromAPI.puestoContacto,
            telefonoContacto: clientesFromAPI.telefonoContacto,
            correoContacto: clientesFromAPI.correoContacto
        })
        if (clientesFromAPI.nombreContacto1) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto1,
                puestoContacto: clientesFromAPI.puestoContacto1,
                telefonoContacto: clientesFromAPI.telefonoContacto1,
                correoContacto: clientesFromAPI.correoContacto1
            })
        }
        if (clientesFromAPI.nombreContacto2) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto2,
                puestoContacto: clientesFromAPI.puestoContacto2,
                telefonoContacto: clientesFromAPI.telefonoContacto2,
                correoContacto: clientesFromAPI.correoContacto2
            })
        }
        if (clientesFromAPI.nombreContacto3) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto3,
                puestoContacto: clientesFromAPI.puestoContacto3,
                telefonoContacto: clientesFromAPI.telefonoContacto3,
                correoContacto: clientesFromAPI.correoContacto3
            })
        }
        if (clientesFromAPI.nombreContacto4) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto4,
                puestoContacto: clientesFromAPI.puestoContacto4,
                telefonoContacto: clientesFromAPI.telefonoContacto4,
                correoContacto: clientesFromAPI.correoContacto4
            })
        }
        if (contactosCliente.length >= 5) {
            const contactos = await GetClienteContactos({ clienteID: { eq: id } });
            if (contactos.length > 0) {
                contactosCliente = [...contactosCliente, ...contactos]

            }
        }
        setContactosClientes(contactosCliente);
        setCargando(false);
        return clientesFromAPI;
    }

    //Guarda los datos de los clientes
    async function createClientes() {
        setAVisible(false);
        setCargando(true);
        setGuardarDisabled(true);
        window.scrollTo(0, 0);
        const resultado = await guardarCliente(formData, imagenRepetida, imagen, false);
        setMensajeAlert(resultado.mensaje);
        setColor(resultado.color);
        setCargando(false);
        setAVisible(true);
        setGuardarDisabled(resultado.deshabilitarBoton);
        if (resultado.completo === true) {
            setEstadoCliente("todos");
            setClientes([...clientes, formData]);
            updateFormData(initialFormState);
            updateFormState(() => ({ ...formState, formType: "Catálogo" }));
        }
    }
    function nuevoContacto() {
        setContacto(contacto + 1);
        if (contacto >= 4)
            setisDisabled(true);
    }

    //actualiza  los datos de los clientes
    async function updateClientes() {
        window.scrollTo(0, 0);
        setAVisible(false);
        setCargando(true);
        setGuardarDisabled(true);
        const actualizarCliente = await actualizarClientes(formData, editarImagen, imagen, mClientes, false);
        setMensajeAlert(actualizarCliente.mensaje);
        setColor(actualizarCliente.color);
        setGuardarDisabled(actualizarCliente.deshabilitarBoton);
        setCargando(false);
        setAVisible(true);
        if (actualizarCliente.error === true) {
            setEditarImagen(false);
        }
        if (actualizarCliente.completo === true) {
            setEditarImagen(false);
            setEstadoCliente("todos");
            setClientes([...clientes, formData]);
            updateFormData(initialFormState);
            fetchClientes();
            updateFormState(() => ({ ...formState, formType: "Catálogo" }));
        }
    }

    //Envía al formulario para crear un nuevo cliente
    async function nuevoCliente() {
        await fetchClientesCotizacion();
        setContacto(1);
        setisDisabled(false);
        setCargando(false);
        setAVisible(false);
        setImagenRepetida(false);
        setGuardarDisabled(false);
        updateFormData({ ...formData, Reg_Ins_Usuario: userName });
        updateFormState(() => ({ ...formState, formType: "Nuevo cliente" }));
    }
    //Envía al formulario de Catálogo
    function catalogo() {
        updateFormData(initialFormState);
        setCargando(false);
        setAVisible(false);
        setEstadoCliente("todos");
        updateFormState(() => ({ ...formState, formType: "Catálogo" }));
    }
    //Envía al formulario de Editar Cliente
    function editarCliente() {
        setCargando(false);
        setAVisible(false);
        setGuardarDisabled(false);
        updateFormData({ ...formData, Reg_Mod_Usuario: userName });
        updateFormState(() => ({ ...formState, formType: "Editar Cliente" }));
    }

    //Diseño de la página
    return (
        <>
            {pclientes === true && (
                <>
                    <row>
                        <div className="headerp">
                            <IoIcons.IoMdPeople className="iconoc floatleft" onClick={catalogo} />
                            <h3 >{formType}</h3>
                        </div>
                    </row>
                    <div className="conteiner5">
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>

                        {cargando === true && (
                            <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            </Row>
                        )}

                        {//Catálogo de clientes
                            formType === 'Catálogo' && (
                                <Fragment>
                                    {!formData.cliente && (
                                        <>
                                            <Row>
                                                <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 text-left " >
                                                    <button class="cbutton btn-success margintop20px " onClick={nuevoCliente}> <span class="fa fa-plus"> Agregar cliente</span> </button>
                                                    <button className="cbutton btn-dark floatright  ml-2 " title="Recargar página" onClick={() => { fetchClientes(); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-left " >
                                                    <Label>Mostrando clientes</Label>
                                                    <select name="clienteestado " className="floatleft custom-select" onChange={sClienteEstado}>
                                                        <option value="todos" >Todos</option>
                                                        <option value="true">Activos</option>
                                                        <option value="false">Inactivos</option>
                                                    </select>
                                                </div>
                                            </Row>
                                            <div>
                                            </div>
                                            <Row>
                                                {clientes.map(cliente => (
                                                    <>
                                                        {estadoCliente === "todos" && (
                                                            <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                                                                {
                                                                    <div>
                                                                        {
                                                                            cliente.image && <img src={cliente.image} alt="logo del cliente" width="100px" onClick={() => onClickCliente(cliente)} className="cursorpointer" />
                                                                        }
                                                                        <h4>{cliente.cliente} </h4>
                                                                        <h4>{cliente.activo}</h4>
                                                                    </div>
                                                                }
                                                            </div>)
                                                        }
                                                        {estadoCliente === cliente.activo.toString() && (
                                                            <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                                                                {
                                                                    <div>
                                                                        {
                                                                            cliente.image && <img src={cliente.image} alt="logo del cliente" width="100px" onClick={() => onClickCliente(cliente)} className="cursorpointer" />
                                                                        }
                                                                        <h4>{cliente.cliente} </h4>
                                                                        <h4>{cliente.activo}</h4>
                                                                    </div>
                                                                }
                                                            </div>)
                                                        }
                                                    </>
                                                )
                                                )
                                                }
                                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(resultados)}</div>*/}
                                            </Row> </>
                                    )}
                                    {formData.cliente && (
                                        <div className="textaligmentleft">
                                            <Row className="margintop20px ">
                                                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <img src={formData.image} alt="imagen" width="100px" />
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                                    <button class=" btn-primary cbutton " color="primary" onClick={editarCliente} title="Editar"> <IoIcons.IoIosCreate />Editar </button>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                                    <button class="btn-info cbutton floatleft" onClick={catalogo} title="Regresar"> <IoIcons.IoMdArrowRoundBack />Regresar </button>
                                                </div>
                                            </Row>
                                            <Row>
                                                <h4 className="col-lg-12 col-md-12 col-sm-12 col-xs-12">{formData.cliente}</h4>
                                                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 ">
                                                    <Label>CLIENTE {formData.activo ? "ACTIVO" : "INACTIVO"}</Label>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="margintop20px col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <Label>INFORMACIÓN DEL CLIENTE</Label>
                                                </div>
                                                <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12"> {formData.descripcion}</p>
                                            </Row>
                                            <Row>
                                                <div>
                                                    <div >
                                                        <div className="margintop20px  col-lg-12 col-md-12 col-sm-12 col-xs-12 "><p>{formData.pais.toUpperCase()}</p> </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12" ><p>{formData.domicilio} {formData.colonia}, {formData.ciudad}, {formData.estado}.</p> </div>
                                                        <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop-16px">Código Postal: {formData.codigoPostal}</p>
                                                    </div>
                                                </div>
                                            </Row>

                                            <Row>
                                                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                                    <Label >Teléfonos</Label>
                                                    <p> {formData.telefono}</p>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                                    <Label >Correos</Label>
                                                    <p> {formData.correo}</p>
                                                </div>
                                            </Row>
                                            <Row>
                                                <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">FACTURACIÓN</p>
                                            </Row>
                                            <p >Tipo: {formData.facturaTipo}</p>
                                            {formData.facturaTipo === "Factura foliada" && (<p className="margintop-16px">Requiere IVA: {formData.requiereIVA === true ? 'Sí' : 'No'}</p>)}
                                            {formData.requiereIVA === true && (<p className="margintop-16px">Porcentaje de IVA: {formData.porcentajeIVA}</p>)}
                                            <p className="margintop-16px">RFC: {formData.rfc}</p>
                                            <p className="margintop-16px">Razón social: {formData.razonSocial}</p>
                                            <p className="margintop-16px">Uso del CFDI: {formData.usoCFDI}</p>
                                            <p>Bill To: {formData.billTo}</p>
                                            <p className="margintop-16px">Ship To: {formData.shipTo}</p>
                                            <Row>
                                                <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">CONTACTO</p>
                                            </Row>
                                            <Row>
                                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll mb-5">
                                                    <Table className=" mb-2 scroll " >
                                                        <Thead class="thead-secondary">
                                                            <Tr>
                                                                <Th>Número</Th>
                                                                <Th className="minwidth200px">Contacto</Th>
                                                                <Th >Puesto</Th>
                                                                <Th>Teléfono</Th>
                                                                <Th >Correo</Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>
                                                            {contactosClientes.map((contacto, i) => (
                                                                <Tr class={(i % 2) !== 0 ? "table-active" : ""} >
                                                                    <Td>{i + 1}</Td>
                                                                    <Td>{contacto.nombreContacto}</Td>
                                                                    <Td >{contacto.puestoContacto}</Td>
                                                                    <Td>{contacto.telefonoContacto}</Td>
                                                                    <Td >{contacto.correoContacto}</Td>
                                                                </Tr>

                                                            ))}
                                                        </Tbody>
                                                    </Table>
                                                </div>
                                            </Row>
                                        </div>)}

                                </Fragment>
                            )
                        }
                        {//Nuevo cliente
                            formType === 'Nuevo cliente' && (
                                <Fragment>
                                    <Row >
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft ">Nombre*</Label>
                                                <div class="input-group">
                                                    <Input name="cliente" value={formData.cliente} maxLength={50} placeholder="Nombre del cliente" onChange={onChanges} />
                                                    <div class="input-group-prepend">
                                                        <button class="cbuttonS floatleft"
                                                            title="Obtener cliente de cotización"
                                                            onClick={toggle}
                                                        >
                                                            <IoIcons.IoIosList />
                                                        </button>
                                                    </div>
                                                </div>
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-5 col-md-10 col-sm-10 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft ">Logo del cliente*</Label>
                                                {<Input
                                                    type="file"
                                                    onChange={onChangeimage}
                                                />}
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-1 col-md-2 col-sm-2 col-xs-12">
                                            <Label for="activo" className="activofloat" >Activo* </Label>
                                            <select name="activo" id="activo" className="activofloat custom-select" onChange={onChanges}>
                                                <option selected={formData.activo === "true" ? true : false} value="true">Sí</option>
                                                <option selected={formData.activo === "false" ? true : false} value="false">No</option>
                                            </select>
                                        </div>
                                    </Row>
                                    <Row >
                                        <Col>
                                            <FormGroup >
                                                <Label className="floatleft" >Descripción</Label>
                                                <Input name="descripcion" value={formData.descripcion} maxLength={800} type="textarea" placeholder="Descripción" ref={inputElement} onChange={onChanges} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row >
                                        <Col>
                                            <FormGroup >
                                                <Label className="floatleft" >Domicilio*</Label>
                                                <Input name="domicilio" value={formData.domicilio} maxLength={300} type="textarea" placeholder="Domicilio" onChange={onChanges} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Colonia*</Label>
                                                <Input name="colonia" value={formData.colonia} maxLength={30} placeholder="Colonia" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Ciudad*</Label>
                                                <Input name="ciudad" value={formData.ciudad} maxLength={30} placeholder="Ciudad" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Estado*</Label>
                                                <Input name="estado" value={formData.estado} maxLength={30} placeholder="Estado" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >País*</Label>
                                                <Input name="pais" value={formData.pais} maxLength={15} placeholder="País" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Código Postal*</Label>
                                                <Input name="codigoPostal" value={formData.codigoPostal} maxLength={10} placeholder="Código postal" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfonos*</Label>
                                                <Input name="telefono" value={formData.telefono} maxLength={100} placeholder="Teléfono" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correos*</Label>
                                                <Input name="correo" value={formData.correo} maxLength={100} placeholder="Correo" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                                            <h4 className="floatleft">Facturación</h4>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                            <Label for="facturaTipo" className="floatleft" >Tipo </Label>
                                            <select name="facturaTipo" id="facturaTipo" className="activofloat custom-select" onChange={onChanges}>
                                                <option selected={formData.facturaTipo === "Invoice " ? true : false} value="Invoice ">Invoice </option>
                                                <option selected={formData.facturaTipo === "Factura foliada" ? true : false} value="Factura foliada">Factura foliada</option>
                                            </select>
                                        </div>
                                        {formData.facturaTipo === "Factura foliada" && (
                                            <>
                                                <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                                    <Label for="requiereIVA" className="floatleft" >Requiere IVA </Label>
                                                    <select name="requiereIVA" id="requiereIVA" className="activofloat custom-select" onChange={onChanges}>
                                                        <option selected={formData.requiereIVA === false ? true : false} value="false">No</option>
                                                        <option selected={formData.requiereIVA === true ? true : false} value="true">Sí</option>
                                                    </select>
                                                </div>
                                                {(formData.requiereIVA === "true" || formData.requiereIVA === true) && (
                                                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                                        <Label for="porcentajeIVA" className="floatleft" >Porcentaje de IVA </Label>
                                                        <select name="porcentajeIVA" id="porcentajeIVA" className="activofloat custom-select" onChange={onChanges}>
                                                            <option selected={formData.porcentajeIVA === "8 %" ? true : false} value="8 %">8 %</option>
                                                            <option selected={formData.porcentajeIVA === "16 %" ? true : false} value="16 %">16 %</option>
                                                        </select>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </Row>
                                    <Row>
                                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                            <FormGroup >
                                                <Label className="floatleft" >RFC</Label>
                                                <Input name="rfc" value={formData.rfc} maxLength={30} placeholder="RFC" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                            <FormGroup >
                                                <Label className="floatleft" >Razón social</Label>
                                                <Input name="razonSocial" value={formData.razonSocial} maxLength={50} placeholder="Razón social" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                            <FormGroup >
                                                <Label className="floatleft" >Uso del CFDI</Label>
                                                <Input name="usoCFDI" value={formData.usoCFDI} maxLength={50} placeholder="Uso del CFDI" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft " >Bill To</Label>
                                                <Input name="billTo" value={formData.billTo} maxLength={1500} type="textarea" placeholder="Bill To" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Ship To</Label>
                                                <Input name="shipTo" value={formData.shipTo} maxLength={1500} type="textarea" placeholder="Ship To" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                                            <h4 className="floatleft">Contacto</h4>
                                        </div>
                                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                            <button class="btn-success  floatright" disabled={isDisabled} onClick={nuevoContacto} title="Agregar contacto"> <span class="fa fa-plus lg"></span> </button>
                                        </div>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Nombre*</Label>
                                                <Input name="nombreContacto" value={formData.nombreContacto} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Puesto*</Label>
                                                <Input name="puestoContacto" value={formData.puestoContacto} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfono*</Label>
                                                <Input name="telefonoContacto" value={formData.telefonoContacto} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correo*</Label>
                                                <Input name="correoContacto" value={formData.correoContacto} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    {contacto > 1 && (
                                        <Row  >
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Nombre</Label>
                                                    <Input name="nombreContacto1" value={formData.nombreContacto1} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Puesto</Label>
                                                    <Input name="puestoContacto1" value={formData.puestoContacto1} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Teléfono</Label>
                                                    <Input name="telefonoContacto1" value={formData.telefonoContacto1} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Correo</Label>
                                                    <Input name="correoContacto1" value={formData.correoContacto1} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                        </Row>
                                    )}
                                    {contacto > 2 && (
                                        <Row  >
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Nombre</Label>
                                                    <Input name="nombreContacto2" value={formData.nombreContacto2} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Puesto</Label>
                                                    <Input name="puestoContacto2" value={formData.puestoContacto2} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Teléfono</Label>
                                                    <Input name="telefonoContacto2" value={formData.telefonoContacto2} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Correo</Label>
                                                    <Input name="correoContacto2" value={formData.correoContacto2} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                        </Row>
                                    )}
                                    {contacto > 3 && (
                                        <Row  >
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Nombre</Label>
                                                    <Input name="nombreContacto3" value={formData.nombreContacto3} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Puesto</Label>
                                                    <Input name="puestoContacto3" value={formData.puestoContacto3} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Teléfono</Label>
                                                    <Input name="telefonoContacto3" value={formData.telefonoContacto3} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Correo</Label>
                                                    <Input name="correoContacto3" value={formData.correoContacto3} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                        </Row>
                                    )}
                                    {contacto > 4 && (
                                        <Row  >
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Nombre</Label>
                                                    <Input name="nombreContacto4" value={formData.nombreContacto4} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Puesto</Label>
                                                    <Input name="puestoContacto4" value={formData.puestoContacto4} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Teléfono</Label>
                                                    <Input name="telefonoContacto4" value={formData.telefonoContacto4} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                                <FormGroup >
                                                    <Label className="floatleft" >Correo</Label>
                                                    <Input name="correoContacto4" value={formData.correoContacto4} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                                                </FormGroup>
                                            </div>
                                        </Row>
                                    )}
                                    <Row> <div className="hr" />  <div className="hr" />    </Row>
                                    <div>
                                        <Button className="floatright" onClick={catalogo} color="danger" >
                                            Cancelar
                                        </Button>
                                        <Button className="floatright" onClick={createClientes} disabled={guardarDisable} color="primary" >
                                            Guardar
                                        </Button>
                                    </div>

                                    <Modal isOpen={modal} size="lg" toggle={toggle}>
                                        <ModalHeader toggle={toggle}>Datos de Clientes de cotizaciones aprobadas{/*Calculate area*/}</ModalHeader>
                                        <ModalBody>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                                <FormGroup >
                                                    <Label ><h5>Busqueda por: </h5></Label>
                                                    <select name="recibabusqueda" onChange={"buscarpor"}>
                                                        <option value="cliente" >Cliente</option>
                                                        <option value="numero de parte">Número de parte</option>
                                                        <option value="id de cotizacion" >ID de cotización</option>
                                                        <option value="fecha">Fecha de cotización</option>
                                                    </select>
                                                    <Input
                                                        type={"searchBy" !== "fecha" ? "text" : "date"}
                                                        placeholder={"Búsqueda por " + "searchBy"}
                                                        onChange={"searchBy" !== "fecha" ? "(e) => setSearch(e.target.value)" : "onSearchFecha"}
                                                        onKeyUp={"searchBy" !== "fecha" ? "onSearch" : ""}
                                                        value={"search"}
                                                    />
                                                </FormGroup>
                                            </div>
                                            {/*Enter the measurements of the piece from the largest area to the smallest, please.*/}
                                            <Row >
                                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                                    <Table className=" mb-2 scroll ">
                                                        <Thead class="thead-secondary">
                                                            <Tr>
                                                                <Th  >#</Th>
                                                                <Th className=" minwidth80px">Cliente</Th>
                                                                <Th className=" minwidth80px">Núm de parte</Th>
                                                                <Th className=" minwidth80px">ID de Cotización</Th>
                                                                <Th className=" minwidth80px">Fecha de cotización</Th>
                                                                <Th className=" minwidth80px">Seleccionar</Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>

                                                            {clientesCotizacion.map((x, i) => {
                                                                return (
                                                                    !x.seleccionado && (
                                                                        <Tr class={x.sombreado ? "table-active" : ""} >
                                                                            <Td>{i + 1}</Td>
                                                                            <Td >
                                                                                {x.cliente}
                                                                            </Td>
                                                                            <Td >
                                                                                {x.numerodeParte}
                                                                            </Td>
                                                                            <Td >
                                                                                {x.quoteNumber}
                                                                            </Td>
                                                                            <Td >
                                                                                {x.date}
                                                                            </Td>
                                                                            <Td className="textaligmentcenter" >
                                                                                {/*e => setInputList(handleInputChangeMedidas(e, i, [...inputList])) */}
                                                                                <button
                                                                                    class="btn-success cbutton "
                                                                                    onClick={() => setClientesCotizacion(seleccionarCliente(x, i, [...clientesCotizacion]))}
                                                                                ><IoIcons.IoMdCheckmark />
                                                                                </button>
                                                                            </Td>
                                                                        </Tr>
                                                                    )
                                                                );
                                                            })}
                                                        </Tbody>
                                                    </Table>

                                                </div>
                                            </Row>
                                        </ModalBody>
                                        {/*<div>{JSON.stringify(formData)}</div>*/}
                                        <ModalFooter>
                                            <Button color="danger" onClick={toggle}>Cerrar</Button>
                                        </ModalFooter>
                                    </Modal>
                                </Fragment>
                            )
                        }
                        {//Editar cliente
                            formType === 'Editar Cliente' && (
                                <Fragment>
                                    <Row >
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft ">Nombre*</Label>
                                                <Input name="cliente" maxLength={50} value={formData.cliente} placeholder="Nombre del cliente" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        {!editarImagen && (
                                            <img src={formData.image} alt="imagen" width="100px" title={formData.imagename} />)}
                                        <div className={editarImagen ? "col-lg-5 col-md-10 col-sm-10 col-xs-12" : "col-lg-4 col-md-10 col-sm-10 col-xs-12"} >
                                            <FormGroup >
                                                <Label className="floatleft ">Logo del cliente*</Label>
                                                <Input
                                                    type="file"
                                                    onChange={onChangeimage}
                                                />
                                            </FormGroup>
                                        </div>

                                        <div className="col-lg-1 col-md-2 col-sm-2 col-xs-12">
                                            <Label for="activo" className="activofloat">Activo* </Label>
                                            <select name="activo" id="activo" className="activofloat" onChange={onChanges}>
                                                <option value="true" selected={formData.activo ? true : false}>Sí</option>
                                                <option value="false" selected={!formData.activo ? true : false} >No</option>
                                            </select>
                                        </div>
                                    </Row>
                                    <Row >
                                        <Col>

                                            <FormGroup >
                                                <Label className="floatleft" >Descripción</Label>
                                                <Input name="descripcion" maxLength={800} value={formData.descripcion} type="textarea" placeholder="Descripción" onChange={onChanges} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row >
                                        <Col>
                                            <FormGroup >
                                                <Label className="floatleft" >Domicilio*</Label>
                                                <Input name="domicilio" maxLength={300} value={formData.domicilio} type="textarea" placeholder="Domicilio" onChange={onChanges} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Colonia*</Label>
                                                <Input name="colonia" maxLength={30} value={formData.colonia} placeholder="Colonia" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Ciudad*</Label>
                                                <Input name="ciudad" maxLength={30} value={formData.ciudad} placeholder="Ciudad" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Estado*</Label>
                                                <Input name="estado" maxLength={30} value={formData.estado} placeholder="Estado" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >País*</Label>
                                                <Input name="pais" maxLength={15} value={formData.pais} placeholder="País" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Código Postal*</Label>
                                                <Input name="codigoPostal" maxLength={10} value={formData.codigoPostal} placeholder="Código postal" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfonos*</Label>
                                                <Input name="telefono" value={formData.telefono} placeholder="Teléfono" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correos*</Label>
                                                <Input name="correo" maxLength={100} value={formData.correo} placeholder="Correo" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                                            <h4 className="floatleft">Facturación</h4>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                            <Label for="facturaTipo" className="floatleft" >Tipo </Label>
                                            <select name="facturaTipo" id="facturaTipo" className="activofloat custom-select" onChange={onChanges}>
                                                {!formData.facturaTipo && (<option selected={true} value=" "> </option>)}
                                                <option selected={formData.facturaTipo === "Invoice " ? true : false} value="Invoice ">Invoice </option>
                                                <option selected={formData.facturaTipo === "Factura foliada" ? true : false} value="Factura foliada">Factura foliada</option>
                                            </select>
                                        </div>
                                        {formData.facturaTipo === "Factura foliada" && (
                                            <>
                                                <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                                    <Label for="requiereIVA" className="floatleft" >Requiere IVA </Label>
                                                    <select name="requiereIVA" id="requiereIVA" className="activofloat custom-select" onChange={onChanges}>
                                                        {!formData.requiereIVA && (<option selected={true} value=" "> </option>)}
                                                        <option selected={formData.requiereIVA === false ? true : false} value="false">No</option>
                                                        <option selected={formData.requiereIVA === true ? true : false} value="true">Sí</option>
                                                    </select>
                                                </div>
                                                {(formData.requiereIVA === "true" || formData.requiereIVA === true) && (
                                                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                                        <Label for="porcentajeIVA" className="floatleft" >Porcentaje de IVA </Label>
                                                        <select name="porcentajeIVA" id="porcentajeIVA" className="activofloat custom-select" onChange={onChanges}>
                                                            {!formData.porcentajeIVA && (<option selected={true} value=" "> </option>)}
                                                            <option selected={formData.porcentajeIVA === "8 %" ? true : false} value="8 %">8 %</option>
                                                            <option selected={formData.porcentajeIVA === "16 %" ? true : false} value="16 %">16 %</option>
                                                        </select>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </Row>
                                    <Row>
                                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                            <FormGroup >
                                                <Label className="floatleft" >RFC</Label>
                                                <Input name="rfc" maxLength={30} value={formData.rfc} placeholder="RFC" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                            <FormGroup >
                                                <Label className="floatleft" >Razón social</Label>
                                                <Input name="razonSocial" maxLength={50} value={formData.razonSocial} placeholder="Razón social" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                            <FormGroup >
                                                <Label className="floatleft" >Uso del CFDI</Label>
                                                <Input name="usoCFDI" maxLength={50} value={formData.usoCFDI} placeholder="Uso del CFDI" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Bill To</Label>
                                                <Input name="billTo" maxLength={50} value={formData.billTo} type="textarea" placeholder="Bill To" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Ship To</Label>
                                                <Input name="shipTo" maxLength={50} type="textarea" value={formData.shipTo} placeholder="Ship To" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                                            <h4 className="floatleft">Contacto</h4>
                                        </div>
                                        {/*<div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                        <button class="btn-success  floatright" disabled={isDisabled} onClick={nuevoContacto} title="Agregar contacto"> <span class="fa fa-plus lg"></span> </button>     
                            </div>  */}
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Nombre*</Label>
                                                <Input name="nombreContacto" maxLength={100} value={formData.nombreContacto} placeholder="Nombre del contatco" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Puesto*</Label>
                                                <Input name="puestoContacto" maxLength={100} value={formData.puestoContacto} placeholder="Puesto del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfono*</Label>
                                                <Input name="telefonoContacto" maxLength={100} value={formData.telefonoContacto} placeholder="Teléfono del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correo*</Label>
                                                <Input name="correoContacto" maxLength={100} value={formData.correoContacto} placeholder="Correo del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Nombre</Label>
                                                <Input name="nombreContacto1" maxLength={100} value={formData.nombreContacto1} placeholder="Nombre del contatco" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Puesto</Label>
                                                <Input name="puestoContacto1" maxLength={100} value={formData.puestoContacto1} placeholder="Puesto del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfono</Label>
                                                <Input name="telefonoContacto1" maxLength={100} value={formData.telefonoContacto1} placeholder="Teléfono del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correo</Label>
                                                <Input name="correoContacto1" maxLength={100} value={formData.correoContacto1} placeholder="Correo del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Nombre</Label>
                                                <Input name="nombreContacto2" maxLength={100} value={formData.nombreContacto2} placeholder="Nombre del contatco" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Puesto</Label>
                                                <Input name="puestoContacto2" maxLength={100} value={formData.puestoContacto2} placeholder="Puesto del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfono</Label>
                                                <Input name="telefonoContacto2" maxLength={100} value={formData.telefonoContacto2} placeholder="Teléfono del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correo</Label>
                                                <Input name="correoContacto2" maxLength={100} value={formData.correoContacto2} placeholder="Correo del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Nombre</Label>
                                                <Input name="nombreContacto3" maxLength={100} value={formData.nombreContacto3} placeholder="Nombre del contatco" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Puesto</Label>
                                                <Input name="puestoContacto3" maxLength={100} value={formData.puestoContacto3} placeholder="Puesto del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfono</Label>
                                                <Input name="telefonoContacto3" maxLength={100} value={formData.telefonoContacto3} placeholder="Teléfono del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correo</Label>
                                                <Input name="correoContacto3" maxLength={100} value={formData.correoContacto3} placeholder="Correo del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row  >
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Nombre</Label>
                                                <Input name="nombreContacto4" maxLength={100} value={formData.nombreContacto4} placeholder="Nombre del contatco" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Puesto</Label>
                                                <Input name="puestoContacto4" maxLength={100} value={formData.puestoContacto4} placeholder="Puesto del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Teléfono</Label>
                                                <Input name="telefonoContacto4" maxLength={100} value={formData.telefonoContacto4} placeholder="Teléfono del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                            <FormGroup >
                                                <Label className="floatleft" >Correo</Label>
                                                <Input name="correoContacto4" maxLength={100} value={formData.correoContacto4} placeholder="Correo del contacto" onChange={onChanges} />
                                            </FormGroup>
                                        </div>
                                    </Row>
                                    <Row> <div className="hr" />  <div className="hr" />    </Row>
                                    <div>
                                        <Button className="floatright" onClick={catalogo} color="danger" >
                                            Cancelar
                                        </Button>
                                        <Button className="floatright" onClick={updateClientes} disabled={guardarDisable} color="primary" >
                                            Guardar
                                        </Button>
                                    </div>
                                </Fragment>
                            )
                        }

                    </div>
                </>
            )}
        </>
    )
}

export default Proveedores
